import { GeneratorCategory } from '@ebalance/proto/bffuser/v1/occto_master_model_pb'
import type { TFunction } from 'i18next'

const CATEGORY_KEYS: Record<GeneratorCategory, string> = {
  [GeneratorCategory.UNSPECIFIED]: '',
  [GeneratorCategory.NUCLEAR]: 'nuclear',
  [GeneratorCategory.HYDRO]: 'hydro',
  [GeneratorCategory.THERMAL_COAL]: 'thermalCoal',
  [GeneratorCategory.THERMAL_GAS]: 'thermalGas',
  [GeneratorCategory.THERMAL_OIL]: 'thermalOil',
  [GeneratorCategory.GEOTHERMAL]: 'geothermal',
  [GeneratorCategory.WIND]: 'wind',
  [GeneratorCategory.SOLAR]: 'solar',
  [GeneratorCategory.PUMPED_STORAGE]: 'pumpedStorage',
  [GeneratorCategory.STORAGE]: 'storage',
  [GeneratorCategory.OTHER]: 'other',
}

/** 発電形式の表示名。UNSPECIFIED は空文字。 */
export function generatorCategoryLabel(
  t: TFunction,
  category: GeneratorCategory,
): string {
  const key = CATEGORY_KEYS[category]
  return key === '' ? '' : t(`page:adminPlantUnitMaster.unit.category.${key}`)
}
